<a class="repository-container" [href]="urlRepository" target="_blank">
  <span class="icon-gitLab"></span>
  <span class="text-gitLab">Ver en GitLab</span>
</a>
